/* npm modules outside of vrbo */

import React from 'react';
import {PropTypes} from 'prop-types';

/* Atoms (baseline) */
import {SVGIcon, TOOLTIP__16} from '../../atoms/baseline/baseline';

/* Atoms (custom) */
import {Typography} from '../../atoms/Typography/Typography';

/* Molecules (baseline) */
import {Tooltip} from '../../molecules/baseline/baseline';

/* Styles */
import './GuestViewAccess.less';

export const GuestViewAccess = ({
    guestAccessLabel,
    placement,
    tooltipContent,
    tooltipType,
    trigger,
}) => {
    return (
        <div className="GuestViewAccess__info">
            <Typography
                className="GuestViewAccess__info-text"
                content={guestAccessLabel}
                TagName="p"
            />
            <Tooltip
                centered
                content={tooltipContent}
                interactiveContent
                placement={placement}
                tooltipType={tooltipType}
                trigger={trigger}
            >
                <SVGIcon className="text-link" markup={TOOLTIP__16} />
            </Tooltip>
        </div>
    );
};

GuestViewAccess.propTypes = {
    guestAccessLabel: PropTypes.string.isRequired,
    placement: PropTypes.string.isRequired,
    tooltipContent: PropTypes.element.isRequired,
    tooltipType: PropTypes.string.isRequired,
    trigger: PropTypes.string.isRequired,
};
